var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item justify-content-between",on:{"click":function($event){return _vm.goToRoom(_vm.roomId)}}},[_vm._v("\n  "+_vm._s(_vm.roomName)+"\n  "),(_vm.roomItemsCount > 0)?_c('span',{staticClass:"badge badge-default badge-pill"},[_vm._v(_vm._s(_vm.roomItemsCount))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f8e92fe","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/children/RoomListItem.vue
// module id = 461
// module chunks = 4